// @material-ui/icons
import Email from "@material-ui/icons/Email";
import LockOutline from "@material-ui/icons/LockOutline";
import Face from "@material-ui/icons/Face";
import Quote from "@material-ui/icons/FormatQuote";
// import Text from "@material-ui/icons/ShortText";
// import InsertPic from "@material-ui/icons/InsertPhoto";
// import PieChart from "@material-ui/icons/PieChart";
import Poll from "@material-ui/icons/Poll";
// import List from "@material-ui/icons/List";
// import AccountBox from "@material-ui/icons/AccountBox";
// import Person from "@material-ui/icons/Person";

//TODO USE ME LATER :)
// import Poll from "@material-ui/icons/Poll";

export const SIGNUP_FIELDS = {
  name: {
    label: 'First and Last Name...',
    inputType: 'text',
    iconType: Face,
    // iconClassName: classes.inputIconsColor, //set on page
  },
  email: {
    label: 'Your Email...',
    inputType: 'email',
    iconType: Email,
    // iconClassName: classes.inputIconsColor, //set on page
  },
  // TODO auto generate username for now, with this
  // https://randomuser.me/api/?nat=us&inc=login
  // username: {
  //   label: 'Choose a Username...',
  //   inputType: 'text',
  //   iconType: Person,
  //   // iconClassName: classes.inputIconsColor, //set on page
  // },
  password: {
    label: 'Password',
    inputType: 'password',
    iconType: LockOutline,
    // iconClassName: classes.inputIconsColor, //set on page
  },
};

export const LOGIN_FIELDS = {
  email: {
    label: 'Your Email...',
    inputType: 'email',
    iconType: Email,
    // iconClassName: classes.inputIconsColor, //set on page
  },
  password: {
    label: 'Password',
    inputType: 'password',
    iconType: LockOutline,
    // iconClassName: classes.inputIconsColor, //set on page
  },
};

export const CREATE_POLL_FIELDS = {
  question: {
    label: 'Question: ',
    placeholder: 'What question is on your mind?',
    inputType: 'text',
    iconType: Quote,
  },
  descrip: {
    label: 'Description: ',
    placeholder: 'Why create this poll? Background info? Examples?',
    inputType: 'text',
    iconType: Quote,
  },
  // img_url: {
  //   label: 'Image Url: ',
  //   inputType: 'text',
  //   iconType: InsertPic,
  // },
  // thumb_url: {
  //   label: 'enter thumb image url...',
  //   inputType: 'text',
  //   // iconType: LockOutline,
  // },
  answer1: {
    label: 'Answer 1: ',
    placeholder: '',
    inputType: 'text',
    iconType: Poll,
  },
  answer2: {
    label: 'Answer 2: ',
    placeholder: '',
    inputType: 'text',
    iconType: Poll,
  },
  answer3: {
    label: 'Answer 3',
    placeholder: '',
    inputType: 'text',
    iconType: Poll,
  },
};

// export default SIGNUP_FIELDS;



// WEBPACK FOOTER //
// ./src/views/formFields.js